
import { formatLocale } from "d3-format";

export function getCurrencyFormat(country) {

    let currency;

    if (country === "krw") {
        currency = ["₩", ""]
    } else if (country === "jpy") {
        currency = ["¥", ""]
    } else {
        currency = ["$", ""]
    }

    const formatDef = {
        "decimal": ".",
        "thousands": ",",
        "grouping": [3],
        "currency": currency
    };
    return formatLocale(formatDef);
}

export function getOhlcFormat(country) {

    if (country === "krw") {
        return (0, getCurrencyFormat(country).format)("$,.0f");
    } else if (country === "jpy") {
        return (0, getCurrencyFormat(country).format)("$,.0f");
    } else {
        return (0, getCurrencyFormat(country).format)("$,.1f");
    }
}


